<template>
  <div :class="{designer_list_item:true,mini:mini_flag}">
    <!-- 左边设计师信息部分 -->
    <div class="designer_info">
      <!-- 头像 -->
      <div class="avatar">
        <img v-lazy="designer_obj.designer.headPath" :key="designer_obj.designer.headPath" alt @click="toDesignerCenter" />
      </div>
      <!-- 基本信息部分 -->
      <div class="base_info">
        <p class="name" @click="toDesignerCenter">
          <span>{{designer_obj.name}}</span>
<!--          <span class="level">lv{{designer_obj.vip_level||'0'}}</span>-->
        </p>
        <!-- 地址 -->
        <p class="address">
          {{designer_obj.school_name}}
          <span class="line"></span>
          {{designer_obj.faculty}}
        </p>
        <!-- 粉丝作品数 -->
        <p class="fans">
          作品:
          <i>{{designer_obj.designer.opus_count}}</i>
          <span class="line opu"></span>
          粉丝:
          <i>{{designer_obj.designer.follow_count}}</i>
        </p>
        <!-- 如果用户是设计师本人，显示上传作品按钮 -->
        <p class="attention" v-if="my_flag">
          <a href="javascript:;" class="attention1" @click="toUploadOpus">上传作品</a>
        </p>
        <!-- 否则显示关注按钮 -->
        <p class="attention" v-else>
          <!-- 关注设计师按钮 -->
          <createFollow
              v-if="!attention.attention_flag"
              :designer_obj="designer_obj.designer"
              :attention="attention"
          ></createFollow>
          <!-- 取消关注设计师按钮 -->
          <cancelFollow v-else :designer_obj="designer_obj.designer" :attention="attention"></cancelFollow>
        </p>
      </div>
    </div>
    <!-- 右边 设计师作品部分 -->
    <div class="designer_opus" @mouseenter="showBtns(true)" @mouseleave="showBtns(false)">
      <div :class="{opus_box:true,opus_box_mini:mini_flag}">
        <div
            class="opus_item"
            v-for="(item, index) in  designer_obj.designer.opus"
            :key="index"
            @click="toOpusDetail(item.id)"
        >
          <img v-lazy="item.coverPath" :key="item.coverPath" alt />
        </div>
      </div>
<!--      <div-->
<!--          class="next"-->
<!--          @click="next()"-->
<!--          v-show="click_counts<(opus_list.length-(mini_flag?2:3))"-->
<!--          :class="{showbtns:btns_flag}"-->
<!--      >-->
<!--        <i class="el-icon-arrow-right"></i>-->
<!--      </div>-->
<!--      <div class="pre" @click="pre()" v-show="click_counts>0" :class="{showbtns:btns_flag}">-->
<!--        <i class="el-icon-arrow-left"></i>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
  import createFollow from "@/components/followDesigner/createFollow.vue";
  import cancelFollow from "@/components/followDesigner/cancelFollow.vue";
  export default {
    components: {
      createFollow,
      cancelFollow
    },
    data() {
      return {
        click_counts: 0, //记录点击按钮次数
        btns_flag: false, //两个按钮显示flag
        next_flag: true, //下一页按钮显示flag
        pre_flag: false, //上一页按钮显示flag
        opus_list: [], //作者右边相关作品列表
        attention: {
          attention_flag: false //关注flag
        },
        j_flag: true, //函数节流flag
        my_flag: false //判断用户是否是设计师本人
      };
    },
    props: {
      // 识别组件的index
      index: {
        type: Number
      },
      // 组件是否小尺寸(true为小尺寸，false为大尺寸)
      mini_flag: {
        type: Boolean
      },
      // 渲染内容 设计师信息
      designer_obj: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    created() {
      // this.getOpuses();
      if (this.info) {
        this.isDesigner();
      } else {
        this.needInfo("isDesigner");
      }
    },
    computed: {
      info() {
        return this.$store.state.info;
      }
    },
    methods: {
      // 跳转上传作品页面
      toUploadOpus() {
        this.$router.push({ name: "upload_opus" });
      },
      needInfo(fn) {
        let watcher = this.$watch("info", (val, oldVal) => {
          if (val) {
            this[fn]();
            watcher();
          }
        });
      },
      // 判断是否是设计师本人
      isDesigner() {
        if (this.designer_obj.designer.user === this.info.id) this.my_flag = true;
        else this.my_flag = false;
        this.attention.attention_flag = this.designer_obj.designer.isFollow;
      },
      // 下一页按钮
      next() {
        if (this.j_flag) {
          this.j_flag = false;
          this.click_counts++;
          let opus_box = document.querySelectorAll(".opus_box")[this.index];
          let opus1 = opus_box.childNodes[0];
          let ml = opus1.style.marginLeft
              ? parseInt(opus1.style.marginLeft.replace("px", ""))
              : 0;
          opus1.style.marginLeft = `${ml - 230}px`;
          setTimeout(() => {
            this.j_flag = true;
          }, 600);
        }
      },
      // 上一页按钮
      pre() {
        if (this.j_flag) {
          this.j_flag = false;
          this.click_counts--;
          let opus_box = document.querySelectorAll(".opus_box")[this.index];
          let opus1 = opus_box.childNodes[0];
          let ml = opus1.style.marginLeft
              ? parseInt(opus1.style.marginLeft.replace("px", ""))
              : 0;
          opus1.style.marginLeft = `${ml + 230}px`;
          setTimeout(() => {
            this.j_flag = true;
          }, 600);
        }
      },
      // 显示两个切换按钮
      showBtns(flag) {
        this.btns_flag = flag;
      },
      // 点击作品跳转详情页面
      toOpusDetail(id, user) {
        this.$router.push({
          name: "pro_detail",
          query: {
            id: id,

          }
        });
      },
      // 跳转教师个人主页
      toDesignerCenter() {
        this.$router.push({
          name: "teacher_detail",
          query: { id: this.designer_obj.id, user: this.designer_obj.user }
        });
      },
      // 获取设计师相关作品
      getOpuses() {
        this.attention.attention_flag = this.designer_obj.designer.isFollow;
        let obj = {
          user_id: this.designer_obj.user,
          is_list: true
        };
        this.api.getOpuses(obj).then(res => {
          console.log(res);
          if (res.error.err_code !== 0) return;
          let list = res.obj.list;
          this.opus_list = list.length ? list : [];
        });
      }
    },
    watch: {
      designer_obj() {
        // this.getOpuses();
        this.isDesigner();
      }
    }
  };
</script>
<style lang="scss">
  .designer_list_item {
    width: 1200px;
    height: 220px;
    box-sizing: border-box;
    background-color: #fff;
    margin-bottom: 10px;
    padding: 30px;
    display: flex;
    justify-content: space-between;
    .designer_info {
      display: flex;
      .avatar {
        img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          cursor: pointer;
        }
      }
      .base_info {
        margin-left: 20px;
        p {
          font-size: 13px;
        }
        .name {
          font-size: 16px;
          color: #333;
          line-height: 27px;
          cursor: pointer;
          span {
            vertical-align: middle;
            display: inline-block;
            max-width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .level {
            font-size: 12px;
            display: inline-block;
            width: 30px;
            line-height: 16px;
            background: rgba(207, 187, 135, 1);
            border-radius: 2px;
            color: #fff;
            text-align: center;
            // line-height: 27px;
            vertical-align: middle;
            margin-left: 8px;
          }
        }
        .fans,
        .address {
          line-height: 27px;
          color: #999;
          .line {
            width: 1px;
            height: 12px;
            background-color: #e2e2e2;
            display: inline-block;
            vertical-align: text-bottom;
            margin: 0 6px;
          }
          .line.opu {
            margin-left: 10px;
          }
          i {
            color: #117eff;
            vertical-align: middle;
          }
          .remark {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
            vertical-align: middle;
          }
        }
        .attention {
          //   line-height: 64px;
          // line-height: 84px;
          a {
            display: inline-block;
            width: 90px;
            box-sizing: border-box;
            border-radius: 2px;
            line-height: 30px;
            text-align: center;
          }
          .attention1 {
            background: rgba(17, 17, 17, 1);
            color: #fff;
          }
          .attention2 {
            color: #333;
            border: 1px solid rgba(51, 51, 51, 1);
            background-color: #fff;
          }
        }
      }
    }
    .designer_opus {
      padding-right: 23px;
      position: relative;
      .opus_box {
        // display: flex;
        width: 680px;
        overflow: hidden;
        white-space: nowrap;
        .opus_item {
          width: 220px;
          height: 160px;
          margin-right: 10px;
          display: inline-block;
          transition: all 0.5s;
          cursor: pointer;
          img {
            width: 100%;
            height: 160px;
            object-fit: cover;
          }
        }
        // .opus_item:first-child {
        //   margin-left: -230px;
        // }
      }
      .opus_box_mini {
        width: 450px;
      }
      .next,
      .pre {
        width: 46px;
        line-height: 46px;
        text-align: center;
        font-size: 20px;
        color: rgba(51, 51, 51, 0.7);
        border-radius: 50%;
        position: absolute;
        top: 57px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 22px 0px rgba(163, 170, 182, 0.5);
        cursor: pointer;
        transition: all 0.3s;
        opacity: 0;
      }
      .showbtns {
        opacity: 1;
      }
      .next {
        right: 0;
      }
      .pre {
        left: -23px;
      }
    }
  }
  .mini {
    width: 862px;
  }
</style>
